var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"forbidden__dialog"},[_vm._v(" عدم دسترسی "),_c('span',[_vm._v("⛔")])])])
}]

export { render, staticRenderFns }